import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectUserById, User } from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';

@Pipe({
  name: 'lookupUser',
})
export class LookupUserPipe implements PipeTransform {
  constructor(private store: Store<AppState>) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: number, ...args: any[]): Observable<User> {
    return this.store.pipe(select(selectUserById(value)));
  }
}
